// @flow
import React from 'react'
import CinemaGraph from '../CinemaGraph/cinemaGraph'
import type { HeaderProps } from '../../types'
import styles from './header.css'

export default ({title, summary, video} : HeaderProps) => (
  <div className={styles.header}>
    <div className={styles.headershare}>
      {/* <button className='nrk-button'>
        <svg width='21' height='21' aria-hidden='true'><use xlinkHref='#nrk-some-facebook' /></svg>
      </button>
      <button className='nrk-button'>
        <svg width='21' height='21' aria-hidden='true'><use xlinkHref='#nrk-some-twitter' /></svg>
      </button> */}
      <a className='nrk-button nrk-button--o' data-share='Article:Facebook' rel='noopener' target='_blank' href='https://www.facebook.com/sharer.php?u=https://nrk.no/spesial/_dusameg-1.13591521'>
        <span className='nrk-sr'>Del på Facebook</span>
        <svg viewBox='0 0 15 15'>
          <title>Del på Facebook</title>
          <path d='M8.4 4.6c0-.5 0-.8.8-.8h1V2H8.7C7 2 6.2 3.2 6.2 4.6v1H4.7v2h1.5V13h2.2V7.5H10l.2-1.8H8.4v-1z' />
        </svg>
      </a>

      <a className='nrk-button nrk-button--o' data-share='Article:Twitter' rel='noopener' target='_blank' href='https://twitter.com/intent/tweet?url=https://nrk.no/spesial/_dusameg-1.13591521&amp;text=Du så meg'>
        <span className='nrk-sr'>Del på Twitter</span>
        <svg viewBox='0 0 15 15'>
          <title>Del på Twitter</title>
          <path d='M14 4c-.4.3-1 .4-1.4.5.5-.3 1-.8 1-1.3-.4.3-1 .4-1.5.6-.3-.5-1-.8-1.7-.8C9 3 7.8 4 7.8 5.4V6C6 5.7 4 5 3 3.3l-.3 1.2c0 1 .4 1.6 1 2-.3 0-.7 0-1-.3 0 1.2.8 2.2 2 2.4h-.7-.5c.4 1 1.3 1.7 2.3 1.7-.8.6-2 1-3 1H2c1 .7 2.4 1 3.8 1 4.5 0 7-3.6 7-6.7v-.3c.5-.4 1-.8 1.2-1.3' />
        </svg>
      </a>
    </div>
    <div className={styles.headercontainer}>
      <h1>{title}</h1>
      <p>{summary}</p>
      <p className={styles.byline}>Av <a href='mailto:gry.karstad@nrk.no'>Gry Kårstad</a> og <a href='mailto:even.kjolleberg@nrk.no'>Even Kjølleberg</a></p>
      {/* <svg width="30" height="30" aria-hidden="true"><use xlink:href="#nrk-chevron-down" /></svg> */}
      <span className={styles.headerarrowcontainer}>
        <span>Scroll deg nedover </span>
        <svg width='30' height='30' aria-hidden='true' className={styles.headerarrow}><use xlinkHref='#nrk-chevron-down' /></svg>
      </span>
    </div>
    <CinemaGraph poster={video.poster} srcset={video.srcset} />
  </div>
)



// WEBPACK FOOTER //
// ./src/shared/components/Header/header.js